// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0874ba3a","150":"b50cfd06","262":"729be16c","311":"a38e095c"}[chunkId] + ".chunk.js";
};